import React from "react";
import HeroImage from "../assets/images/Hero.png";
import { motion } from "framer-motion";

const HeroSection = () => {
  return (
    <section className="min-h-screen bg-bgcolor flex items-center justify-center font-avant relative overflow-visible">
      
      <div className="container mx-auto px-6 flex flex-col lg:flex-row items-center md:items-start justify-between relative lg:top-10">
        
        {/* Left Side: Text */}
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          className="lg:w-1/2 text-white text-center lg:text-left space-y-4 lg:ml-36 lg:mt-5 z-20"
        >
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold lg:leading-tight">
            Stay Connected <br />
            Stay Social <br />
            Stay You!
          </h1>

          <p className="text-white/90 text-base sm:text-lg max-w-md lg:max-w-lg mb-8">
            A place where friendships grow, communities thrive, and moments turn into unforgettable experiences. Whether you're looking to reconnect with old friends, build new relationships, or share what matters most to you – MyBindle is your home on the internet.
          </p>

          <button className="bg-white text-bgcolor px-6 sm:px-8 py-2 sm:py-3 rounded-xl font-bold text-base sm:text-lg shadow-lg hover:shadow-2xl transition-all active:scale-95">
            Get Started
          </button>
        </motion.div>

        {/* Right Side: Image + Floating Popups */}
        <div className="lg:w-1/2 relative mt-10 lg:mt-0 flex justify-center items-center">
          <motion.img
            src={HeroImage}
            alt="MyBindle App"
            className="w-40 sm:w-52 md:w-64 lg:w-[350px] xl:w-[400px] z-10 rounded-2xl"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
          />

          {/* Floating Chat Popup 1 */}
          <motion.div
            animate={{ y: [0, -10, 0] }}
            transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
            className="absolute top-7 sm:top-4 lg:top-16 -left-20 sm:left-5 lg:left-10 z-20 bg-white p-2 sm:p-3 rounded-xl shadow-lg flex items-center gap-2 border border-gray-100 w-32 lg:w-auto"
          >
            <span className="text-base sm:text-lg lg:py-1">🔥</span>
            <p className="text-zinc-800 font-semibold text-xs sm:text-sm lg:text-base">
              Seamless Connections
            </p>
          </motion.div>

          {/* Floating Chat Popup 2 */}
          <motion.div
            animate={{ y: [0, 10, 0] }}
            transition={{ duration: 3, repeat: Infinity, ease: "easeInOut", delay: 1 }}
            className="absolute bottom-9 sm:bottom-4 lg:bottom-32 -right-7 sm:right-5 lg:right-36 z-20 bg-white p-2 sm:p-3 rounded-xl shadow-lg flex items-center gap-2 border border-gray-100 w-28 lg:w-auto"
          >
            <span className="text-base sm:text-lg lg:py-1">🌎</span>
            <p className="text-zinc-800 font-semibold text-xs sm:text-sm lg:text-base">
              Discover & Explore
            </p>
          </motion.div>
        </div>
      </div>

      {/* Background Glow */}
      <div className="absolute w-72 sm:w-96 md:w-[400px] h-72 sm:h-96 md:h-[400px] bg-white/10 rounded-full blur-[120px] -z-10 top-16 right-0"></div>
      
    </section>
  );
};

export default HeroSection;
